import { useTranslation } from 'react-i18next'

import { Badge } from '@/shared/components/ui/badge'

type LifecycleProps = {
	lifecycle_weeks: number
}
export default function Lifecycle({ data }: { data: LifecycleProps }) {
	const { t } = useTranslation()

	return (
		<div className='flex flex-col items-center pt-2'>
			<Badge className='text-xs'>
				{data.lifecycle_weeks} {t('general_weeks_ago')}
			</Badge>
			<p className='mt-2 text-sm text-muted-foreground'>
				{t('general_lifecycle_start')}
			</p>
		</div>
	)
}
